
class IntroductionModel {
    id: number;
    title: string;
    isActive: boolean;

    constructor(
        id: number,
        title: string,
        isActive: boolean,
    ) {
        this.id = id;
        this.title = title;
        this.isActive = isActive;
    }

    public static fromJson(json: any): IntroductionModel {
        return new IntroductionModel(
            json["id"],
            json["title"],
            json["isActive"],
        );
    }
}


export interface IntroductionGetPayloadFilterModel {
    id?: number;
    title?: string;
    isActive?: number;
}

export interface IntroductionGetPayloadModel {
    pageSize?: number;
    pageNumber?: number;
    Filters?: IntroductionGetPayloadFilterModel;
}


export interface IntroductionPayloadModel {
    id: number;
    title: string;
    isActive: boolean;

}
export default IntroductionModel;
